import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { OptionsService } from '../../../../../../../services/survey/options.service';
import { Option } from 'src/app/models/survey/options';
import { Message } from '../../../../../../../models/message';

@Component({
  selector: 'app-svoption-form',
  templateUrl: './svoption-form.component.html',
  styleUrls: ['./svoption-form.component.scss']
})
export class SvoptionFormComponent implements OnInit {

  form: FormGroup;
  svoption: Option = null;
  msg: Message = { status: null, message: null };
  hiddenMsg: boolean = true;
  edit: boolean = false;
  idquestionSelected: number = null;

  constructor(
    private router: Router,
    private optionS: OptionsService,
    private fb: FormBuilder,
    private activedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.createForm();
    this.getSvOption(params);    
  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      idquestion: [null],
      isMatrix: [false],
      label: [''],
      order: ['', Validators.required],
      isActive: [true]
    })
  }

  getSvOption(params: any) {
    if (params.id) {
      this.optionS.getOne(params.id)
        .subscribe(
          res => {
            this.svoption = res['data'];
            this.idquestionSelected = this.svoption.idquestion;
            this.loadData();
            this.edit = true;
          },
          err => console.error(err)
        );
    } else if (params.idquestion) {
      this.idquestionSelected = params.idquestion;
      this.edit = false;
    }
  }

  loadData() {
    this.form.reset(this.svoption);
  }

  cancel() {
    this.routingToList();
  }

  validateForm() {
    if (this.form.invalid) {
      return Object.values(this.form.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      this.edit ? this.update(this.form.value.id, this.form.value) : this.create(this.form.value);

    }
  }

  routingToList() {
    this.router.navigate(['/encuesta/encuestas/seccion/question/option/list', this.idquestionSelected]);
  }

  create(svoption: Option) {
    delete svoption.id;
    svoption.idquestion = +this.idquestionSelected;
    this.optionS.create(svoption)
      .subscribe(
        res => {
          this.msg.message = res['message'];
          this.hiddenMsg = false;
          this.routingToList();
        },
        err => {
          this.msg.status = err["error"].status;
          this.msg.message = err["error"].message;
        }
      )
  }

  update(id: string, svoption: Option) {
    delete svoption.id;
    this.optionS.update(id, svoption).subscribe(
      res => {
        this.msg.message = res['message'];
        this.routingToList();
      },
      err => {
        this.msg.status = err["error"].status;
        this.msg.message = err["error"].message;
      }
    );
  }

  campoNoValido(campo: string) {
    return this.form.get(campo).invalid && this.form.get(campo).touched;
  }

}
